export default __webpack_public_path__ + "static/media/20t.c41d1a69.jpg";